import script from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=1c5e05de&lang=css"
import "./CustomCursor.vue?vue&type=style&index=1&id=1c5e05de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5e05de"]])

export default __exports__